export default __webpack_public_path__ + "static/media/car.inline.1e57f2a4.svg";